module.exports = __webpack_public_path__ + "img/fleche-voir-toutes-nos-infos.019baaad.svg";